import { PersonModel } from './autogen/PersonModel';
import { AbstractDocumentKind } from "./autogen/AbstractDocumentKind";
import { AbstractDocumentType } from "./autogen/AbstractDocumentType";
import { FrequentlyAskedQuestionModel } from "./autogen/FrequentlyAskedQuestionModel";
import { IssueBriefModel } from "./autogen/IssueBriefModel";
import { DebateNotesModel } from "./autogen/DebateNotesModel";
import { MediaLinesModel } from "./autogen/MediaLinesModel";
import { MemberOfParliamentModel } from "./autogen/MemberOfParliamentModel";
import { assertNever } from "../utils/never";
import { DebateNoteSubType } from "./autogen/DebateNoteSubType";
import { GovernmentBillStage } from "./autogen/GovernmentBillStage";
import { PartyPosition } from "./autogen/PartyPosition";
import { OpinionEditorialModel } from './autogen/OpinionEditorialModel';
import { QuoteModel } from './autogen/QuoteModel';
import { AchievementModel } from './autogen/AchievementModel';
import { ResourceModel } from './autogen/ResourceModel';
const shortid = require("shortid");

function createFAQ(): FrequentlyAskedQuestionModel {
    return {
        id: -1,
        type: AbstractDocumentKind.FAQ,
        title: "",
        author: "",
        tags: [],
        answer: "",
        links: [],
        date: new Date(),
        lastUpdated: new Date(),
        createTags: [],
        files: [],
        assignFiles: []
    };
}

function createPerson(): PersonModel {
    return {
        id: -1,
        type: AbstractDocumentKind.Person,
        title: "",
        facebook: "",
        twitter: "",
        firstName: "",
        lastName: "",
        personType: 0,
        partyAffiliation: "NA",
        author: "",
        quotes: [],
        tags: [],
        date: new Date(),
        lastUpdated: new Date(),
        createTags: [],
        twitterHandles: []
    };
}

function createIssueBrief(): IssueBriefModel {
    return {
        id: -1,
        type: AbstractDocumentKind.IssueBrief,
        title: "",
        author: "",
        summary: "",
        body: "",
        tags: [],
        date: new Date(),
        files: [],
        assignFiles: [],
        createTags: []
    };
}

function createAchievement(): AchievementModel {
    return {
        id: -1,
        type: AbstractDocumentKind.Achievement,
        title: "",
        author: "",
        summary: "",
        body: "",
        tags: [],
        date: new Date(),
        files: [],
        assignFiles: [],
        createTags: []
    };
}

function createResource(): ResourceModel {
    return {
        id: -1,
        type: AbstractDocumentKind.Resource,
        title: "",
        author: "",
        summary: "",
        body: "",
        tags: [],
        date: new Date(),
        files: [],
        assignFiles: [],
        createTags: []
    };
}

function createProfileOfMP(): MemberOfParliamentModel {
    return {
        id: -1,
        person: createPerson(),
        type: AbstractDocumentKind.ProfileOfMP,
        title: "",
        author: "",
        tags: [],
        createTags: [],
        items: [
            { order: 0, inline: false, title: "Career timeline", content: "", guid: shortid.generate() },
            { order: 1, inline: false, title: "Ministerial record", content: "", guid: shortid.generate() },
            { order: 2, inline: false, title: "Notable Episodes", content: "", guid: shortid.generate() },
            { order: 3, inline: false, title: "Labour Notes", content: "", guid: shortid.generate() }
        ],
        lastName: "",
        firstName: "",
        links: [],
        topLine: "",
        date: new Date()
    };
}

function createDebateNotes(): DebateNotesModel {
    // return { id: -1, title: "", author: 0, date: new Date(), tags: [], items: [], type }
    return {
        id: -1,
        title: "New Debate Note",
        author: "",
        date: new Date(),
        summary: "Insert summary bullet points here",
        partyPosition: PartyPosition.Support,
        subType: DebateNoteSubType.GovernmentBill,
        billStage: GovernmentBillStage.First,
        tags: [],
        files: [],
        assignFiles: [],
        links: [],
        createTags: [],
        items: [
            { order: 0, inline: false, title: "The Government's overall lines", content: "These will be inserted by the Whips' Office", guid: shortid.generate() },
            { order: 1, inline: false, title: "General lines in this area", content: "These will be inserted by the Whips' Office", guid: shortid.generate() },
            { order: 2, inline: false, title: "Why we support this Bill", content: "Insert your content here, including reasons why the Bill is a good idea", guid: shortid.generate() },
            { order: 3, inline: false, title: "What the Bill does", content: "Insert your content here, including high-level, non-technical summary of what the Bill does", guid: shortid.generate() },
            { order: 4, inline: false, title: "How the Bill fits with our larger plan", content: "Insert your content here, including reference to the government's larger objectives and listing relevant achievements to date", guid: shortid.generate() },
            { order: 5, inline: false, title: "What National left us", content: "Insert your content here, including issues the government inherited in this area from the previous government", guid: shortid.generate() }
        ],
        type: AbstractDocumentKind.DebateNotes
    };
}

function createMediaLines(): MediaLinesModel {
    return {
        id: -1,
        title: "",
        author: "",
        date: new Date(),
        tags: [],
        createTags: [],
        items: [
            { order: 1, inline: false, title: "What", content: "", guid: shortid.generate() },
            { order: 2, inline: false, title: "Key Messages", content: "", guid: shortid.generate() }
        ],
        type: AbstractDocumentKind.MediaLines,
        files: [],
        assignFiles: []
    }
}

function createOpinionEditorial(): OpinionEditorialModel {
    return {
        id: -1,
        title: "",
        author: "",
        dateField: new Date(),
        files: [],
        assignFiles: [],
        date: new Date(),
        summary: "",
        body: "",
        tags: [],
        createTags: [],
        type: AbstractDocumentKind.OpinionEditorial
    }
}

function createQuote(): QuoteModel {
    return {
        id: -1,
        topic: "",
        phrase: "",
        subjects: [],
        person: {} as PersonModel,
        assignFiles: [],
        files: [],
        dateOfQuote: new Date(),
        sourceURL: "",
        tags: [],
        createTags: [],
        date: new Date(),
        title: "",
        author: "",
        type: AbstractDocumentKind.Quote
    }
}



export function isDebateNotes(doc: AbstractDocumentType): doc is DebateNotesModel {
    return doc.type == AbstractDocumentKind.DebateNotes;
}

export function createNewDocument(type: AbstractDocumentKind): AbstractDocumentType {
    switch (type) {
        case AbstractDocumentKind.FAQ:
            return createFAQ();
        case AbstractDocumentKind.Person:
            return createPerson();
        case AbstractDocumentKind.IssueBrief:
            return createIssueBrief();
        case AbstractDocumentKind.Achievement:
            return createAchievement();
        case AbstractDocumentKind.Resource:
            return createResource();
        case AbstractDocumentKind.ProfileOfMP:
            return createProfileOfMP();
        case AbstractDocumentKind.DebateNotes:
            return createDebateNotes();
        case AbstractDocumentKind.MediaLines:
            return createMediaLines();
        case AbstractDocumentKind.OpinionEditorial:
            return createOpinionEditorial();
        case AbstractDocumentKind.Quote:
            return createQuote();
    }
    assertNever(type);
}



// WEBPACK FOOTER //
// ./src/model/factory.ts